import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext.tsx';

const HeroSection: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="container-max">
        <div className="text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 animate-fade-in">
            {t('hero.title')}
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-white/90 max-w-3xl mx-auto animate-slide-up">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-slide-up">
            <Link
              to="/coming-soon"
              className="btn-secondary text-lg px-8 py-4 hover:bg-white/20 hover:border-white/30"
            >
              {t('hero.getstarted')}
            </Link>
            <Link
              to="/contact"
              className="btn-outline text-lg px-8 py-4 hover:bg-white hover:text-primary-600"
            >
              {t('hero.learnmore')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
